import { Printer } from "lucide-react";
import SEO from "@/components/SEO";
import { PageHero } from "@/components/site";
import { COMPANY, CONTACT } from "@/data/content";

export function LegalShell({ title, overline, updated, seoDesc, children, testid }) {
  return (
    <div data-testid={testid}>
      <SEO title={title} description={seoDesc} />
      <PageHero overline={overline} title={title} />
      <section className="py-16 sm:py-20">
        <div className="mx-auto max-w-3xl px-5 sm:px-8">
          <div className="flex items-center justify-between mb-10 pb-6 border-b border-brandborder">
            <p className="text-sm text-slate">Version 1.0 · {updated}</p>
            <button
              onClick={() => window.print()}
              data-testid="legal-download-pdf"
              className="inline-flex items-center gap-2 border border-brandborder text-navy font-semibold text-sm px-4 py-2 rounded-sm hover:border-brandblue transition-colors"
            >
              <Printer size={16} /> Download PDF
            </button>
          </div>
          <div className="legal-prose space-y-6 text-slate leading-relaxed">{children}</div>
          <div className="mt-12 pt-6 border-t border-brandborder text-sm text-slate">
            <p className="italic">This document is pending solicitor sign-off before go-live.</p>
            <p className="mt-3">{COMPANY.name} · Registered in {COMPANY.jurisdiction}{COMPANY.regNumber ? ` · Company No. ${COMPANY.regNumber}` : ""}.</p>
            <p className="mt-1">Questions: <a href={`mailto:${CONTACT.privacyEmail}`} className="text-brandblue font-semibold">{CONTACT.privacyEmail}</a></p>
          </div>
        </div>
      </section>
    </div>
  );
}

export function H2({ children }) {
  return <h2 className="font-heading font-bold text-2xl text-navy pt-4">{children}</h2>;
}
export function P({ children }) {
  return <p className="text-slate leading-relaxed">{children}</p>;
}
export function UL({ items }) {
  return (
    <ul className="space-y-2">
      {items.map((it, i) => (
        <li key={i} className="flex items-start gap-2.5">
          <span className="mt-2 w-1.5 h-1.5 bg-cyan rounded-full shrink-0" />
          <span className="text-slate">{it}</span>
        </li>
      ))}
    </ul>
  );
}
